export default __webpack_public_path__ + "static/media/background_image.58235dc8.jpg";